import React from 'react';
import SimpleForm from '../teal-react/components/organisms/SimpleForm';
import { useSave } from '../graphql/hooks';
import { Alert } from '@mui/material';

interface ProductFormProps {
  model: any;
  onClose: () => void;
  onCreate: (id: number) => void;
}
const ProductForm = ({ model, onClose, onCreate }: ProductFormProps) => {
  const save = useSave('product', ['product', 'productList']);
  const [message, setMessage] = React.useState('');

  return (
    <>
      <SimpleForm
        header="Product Editor"
        model={model}
        cancel={onClose}
        save={(props: any) => {
          const { modified, merged } = props;
          if (model.id) {
            save({
              id: model.id,
              ...modified,
            });
            onClose();
          } else {
            save(merged, true).then((data: any) => {
              if (data.createproduct) {
                onCreate(data.createproduct);
                onClose();
              } else {
                setMessage('That Product Code is already in use!');
              }
            });
          }
        }}
        fields={[
          {
            name: 'code',
            label: 'Product Code',
            size: 3,
            validate: { required: true },
          },
          {
            name: 'shortname',
            label: 'Product Number',
            size: 3,
            validate: { required: true },
          },
          {
            name: 'name',
            label: 'Product Name',
            size: 6,
            validate: { required: true },
          },
          {
            name: 'shelflife',
            label: 'Shelf Life',
            size: 6,
            validate: { required: true },
            options: [
              { value: '6-8 Months', label: '6-8 Months' },
              { value: '1 Year', label: '1 Year' },
              { value: '2 Years', label: '2 Years' },
            ],
          },
          {
            content: message ? <Alert severity="error">{message}</Alert> : null,
          },
        ]}
      />
    </>
  );
};

export default ProductForm;
